import type { ProviderToken } from '@angular/core';
import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { Auth } from '@freelancer/auth';
import type { AuthServiceInterface } from '@freelancer/auth/interface';
import { Location } from '@freelancer/location';
import { map } from 'rxjs/operators';

export const authGuardFactory = (
  authProviderToken: ProviderToken<AuthServiceInterface>,
): ((
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => ReturnType<CanActivateFn>) => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(authProviderToken);
    const router = inject(Router);
    const location = inject(Location);

    return auth.isLoggedIn().pipe(
      map(loggedIn => {
        if (!loggedIn) {
          // eslint-disable-next-line local-rules/no-navigate-in-guard
          router.navigate(['/login'], {
            queryParams: {
              next: encodeURIComponent(location.url),
            },
          });
          return false;
        }
        return true;
      }),
    );
  };
};

export const AuthGuard = authGuardFactory(Auth);
